import styled from 'styled-components';

const Strong = styled.strong`
  font-weight: bold;
`;

export default Strong;
